import axios from 'axios';
import api from './api.service';

export default {
  getViaCep: (cep = '') => axios.get(`https://viacep.com.br/ws/${cep}/json/`),

  getCepInfo: (cep = '') => api.get(`address/cep-info?cep=${cep}`),
};
